import { render, staticRenderFns } from "./AttachmentDropzone.vue?vue&type=template&id=f247b2b2&scoped=true"
import script from "./AttachmentDropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentDropzone.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AttachmentDropzone.vue?vue&type=style&index=0&id=f247b2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f247b2b2",
  null
  
)

export default component.exports